import React, { useEffect, useRef, useState } from "react";
import * as cls from "./learningPlanMobile.module.scss";
import { Icon, WidgetFrame } from "../../../personal-studio-components/studio";
import Cell from "../../components/Cell/Cell";
import ModalZetLessons from "../../components/modalZetLessons/ModalZetLessons";
import LegendLingraph from "./LegendLingraph";
import LearningHeader from "./LearningHeader";

const daysInMonth = (month, year) => {
  return new Date(year, month + 1, 0).getDate();
};
// запись в ветке learning plan
const zetColors = [
  "rgb(178, 211, 62)",
  "rgb(70, 101, 51)",
  "rgb(255, 203, 5)",
  "rgb(134, 40, 51)",
  "rgb(121, 60, 86)",
  "rgb(239, 70, 91)",
  "rgb(161, 161, 161)",
  "rgb(20, 69, 121)",
  "rgb(59, 124, 190)",
  "rgb(46, 178, 226)",
  "rgb(85, 140, 235)",
  "rgb(171, 197, 227)",
  "rgb(82, 93, 104)",
  "rgb(134, 142, 149)",
];

function LearningPlanMobile({
  data,
  getLinegraph,
  currentCourse,
  setCurrentCourse,
}) {
  const [currCellBorder, setCurrCellBorder] = useState({});
  const [tableHeight, setTableHeight] = useState(0);
  const tableRef = useRef(null);
  const [isScrollTable, setIsScrollTable] = useState(false);
  const [currPageIndex, setCurrPageIndex] = useState(0);
  const [startTouch, setStartTouch] = useState(null);
  const [endTouch, setEndTouch] = useState(null);
  useEffect(() => {
    if (tableRef.current) {
      if (tableRef?.current.offsetWidth <= 768) {
        setIsScrollTable(true);
      }
      setTableHeight(tableRef.current.offsetHeight);
    }
  }, [data, currentCourse, tableRef?.current?.offsetWidth]);

  const {
    columns,
    start_date,
    end_date,
    columns_count,
    max_rows_count,
    semesters,
    days_count,
  } = data[currentCourse];
  const MAX_DAYS_PER_PAGE = 100;

  const pages = [];
  let currentPage = [];
  let currentSum = 0;

  for (const col of columns) {
    // если колонка полностью помещается на текущую страницу
    if (currentSum + col.days_count <= MAX_DAYS_PER_PAGE) {
      currentPage.push({
        ...col,
        days_part: col.days_count, // вся колонка помещается
      });
      currentSum += col.days_count;
    } else {
      // колонка не помещается → сохраняем текущую страницу и начинаем новую
      if (currentPage.length > 0) {
        pages.push(currentPage);
      }
      currentPage = [
        {
          ...col,
          days_part: col.days_count,
        },
      ];
      currentSum = col.days_count;
    }
  }

  // добавляем последнюю страницу, если осталась
  if (currentPage.length > 0) {
    pages.push(currentPage);
  }

  const currPage = pages[currPageIndex];
  const total_days_count = currPage.reduce((acc, el) => acc + el.days_count, 0);
  const startDate = new Date(currPage[0].start_date);
  const endDate = new Date(currPage[currPage.length - 1].end_date);
  const today = new Date();
  const months = [];
  let firstMonth;
  for (
    let date = firstMonth
      ? firstMonth
      : new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    date <= endDate;
    date.setMonth(date.getMonth() + 1)
  ) {
    months.push(new Date(date));
  }

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const leftPaddingDays = startDay > 1 ? startDay - 1 : 0;
  const endMonthDays = daysInMonth(endDate.getMonth(), endDate.getFullYear());
  const rightPaddingDays = endDay < endMonthDays ? endMonthDays - endDay : 0;

  const width = currPage.length;
  const height = max_rows_count;

  let twoDimensionalArray = Array.from({ length: height }, () =>
    Array(width).fill(null)
  );
  const arr = [];
  const handleTouchStart = (e) => {
    setStartTouch({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY,
    });
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEndTouch({
      x: e.targetTouches[0].clientX,
      y: e.targetTouches[0].clientY,
    });
  };

  const handleTouchEnd = (e) => {
    if (!startTouch || !endTouch) return;
    const minSwipeDistance = 50;
    const distance = endTouch.x - startTouch.x;
    const touchHeight = endTouch.y - startTouch.y;
    if (touchHeight > 100 || touchHeight < -100) return;
    if (distance > minSwipeDistance) {
      setCurrPageIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (distance < -minSwipeDistance) {
      setCurrPageIndex((prev) => (prev < pages.length - 1 ? prev + 1 : prev));
    }
  };
  pages[currPageIndex].forEach((column, colIndex) => {
    column.rows.forEach((row) => {
      if (row.is_holiday) {
        twoDimensionalArray = twoDimensionalArray.map((el) => {
          el = el.map((item, idx) => {
            if (idx === colIndex) {
              item = row;
            }
            return item;
          });
          return el;
        });
      }
      const rowIndex = row.row_index ? row.row_index - 1 : 0;
      if (rowIndex < height && colIndex < width) {
        twoDimensionalArray[rowIndex][colIndex] = row;
      }
    });
  });
  for (let i = 0; i < twoDimensionalArray.length; i++) {
    const element = twoDimensionalArray[i];
    for (let k = 0; k < element.length; k++) {
      if (element[k] === null) continue;
      const item = element[k];
      if (
        !arr.includes(item.ind_mod_discip_id) &&
        item.show_content !== false
      ) {
        arr.push(item.ind_mod_discip_id);
        twoDimensionalArray[i][k].isDiscipNameRender = true;
      }
    }
  }
  if (twoDimensionalArray) {
    setLabelPosition(twoDimensionalArray);
  }
  const dayToPercentage = (days) => {
    return (days / total_days_count) * 100;
  };
  const calculateInnerWidth = (desiredOverallPercentage, columnPercentage) => {
    return (desiredOverallPercentage / columnPercentage) * 100;
  };

  const highlightCell = (cellData) => {
    setCurrCellBorder({
      ind_mod_discip_id: cellData.ind_mod_discip_id,
      semester_id: cellData.semester_id,
    });
  };
  // добавляем нулловые ячейки
  const restoredColumns = pages[currPageIndex].map((col, colIndex) => {
    const rows = twoDimensionalArray.map((row, rowIndex) => {
      const cell = row[colIndex];

      if (cell === null) {
        return {
          row_index: rowIndex + 1,
          isEmpty: true,
          original_null: true,
        };
      }
      return cell;
    });

    return {
      ...col,
      rows,
    };
  });

  function setLabelPosition(data) {
    const disciplineMap = {};
    // очистка прошлых флагов
    data.forEach((row) =>
      row.forEach((cell) => {
        if (!cell) return;
        delete cell.renderLabel;
        delete cell.renderPercentPaid;
        delete cell.maxTotalDays;
      })
    );

    // собираем все ячейки по дисциплине
    data.forEach((row, rowIndex) => {
      row.forEach((cell, idx) => {
        if (!cell) return;
        const { ind_mod_discip_id, semester_id } = cell;
        const key = `${ind_mod_discip_id || "null"}_${semester_id || "null"}`;
        if (!disciplineMap[key]) disciplineMap[key] = [];
        cell._rowIndex = rowIndex;
        if (row[idx + 1] && row[idx + 1].is_holiday) {
          cell.isNextCellHoliday = true;
        }
        disciplineMap[key].push(cell);
      });
    });

    for (const key in disciplineMap) {
      const cells = disciplineMap[key];

      if (!cells.length) continue;

      // группируем в блоки (DFS)
      const visited = new Set();
      const blocks = [];

      function cellId(c) {
        return `${c._rowIndex}_${c.column_index}`;
      }
      function neighbors(c) {
        return cells.filter(
          (o) =>
            o !== c &&
            ((o._rowIndex === c._rowIndex &&
              Math.abs(o.column_index - c.column_index) === 1) ||
              (o.column_index === c.column_index &&
                Math.abs(o._rowIndex - c._rowIndex) === 1))
        );
      }
      function dfs(start, block) {
        const id = cellId(start);
        if (visited.has(id)) return;
        visited.add(id);
        block.push(start);
        neighbors(start).forEach((n) => dfs(n, block));
      }

      for (const c of cells) {
        if (!visited.has(cellId(c))) {
          const block = [];
          dfs(c, block);
          blocks.push(block);
        }
      }

      // обработка каждого блока
      blocks.forEach((block) => {
        // считаем totalDays по строкам в блоке

        const rowsMap = {};
        block.forEach((c) => {
          rowsMap[c._rowIndex] =
            (rowsMap[c._rowIndex] || 0) + (c.days_count || 0);
        });

        const maxDays = Math.max(...Object.values(rowsMap));

        const bestRowIndex = Math.min(
          ...Object.keys(rowsMap)
            .filter((r) => rowsMap[r] === maxDays)
            .map(Number)
        );

        // ищем самую левую ячейку в выбранной строке
        const bestRowCells = block.filter((c) => c._rowIndex === bestRowIndex);

        if (bestRowCells.length > 0) {
          let leftmost;

          // проверяем, есть ли каникулы в строке
          const hasHoliday = bestRowCells.some((c) => c.isNextCellHoliday);

          if (hasHoliday) {
            // разбиваем строку на сегменты по каникуле
            let segments = [];
            let current = [];
            for (let c of bestRowCells) {
              current.push(c);
              if (c.isNextCellHoliday) {
                segments.push(current);
                current = [];
              }
            }
            if (current.length) segments.push(current); // оставшийся сегмент

            // выбираем сегмент с максимальной суммой days_part
            let bestSegment = segments.reduce((best, seg) => {
              const totalDays = seg.reduce(
                (sum, c) => sum + (c.days_count || 0),
                0
              );
              if (!best || totalDays > best.totalDays)
                return { segment: seg, totalDays };
              return best;
            }, null);

            // самая левая ячейка выбранного сегмента
            leftmost = bestSegment.segment.reduce((min, c) =>
              c.column_index < min.column_index ? c : min
            );
          } else {
            // обычный случай — самая левая ячейка строки
            leftmost = bestRowCells.reduce((min, c) =>
              c.column_index < min.column_index ? c : min
            );
          }

          leftmost.renderLabel = true;
          leftmost.maxTotalDays = maxDays;
        }

        // ставим renderPercentPaid в самой нижней строке блока (самая левая ячейка)
        const bottomRowIndex = Math.max(...Object.keys(rowsMap).map(Number));
        const bottomCells = block.filter((c) => c._rowIndex === bottomRowIndex);
        if (bottomCells.length > 0) {
          const leftBottom = bottomCells.reduce((min, c) =>
            c.column_index < min.column_index ? c : min
          );
          leftBottom.renderPercentPaid = true;
        }
      });
    }

    // очистим временный _rowIndex
    data.forEach((row) =>
      row.forEach((cell) => {
        if (cell) delete cell._rowIndex;
      })
    );
  }

  return (
    <ModalZetLessons>
      <WidgetFrame type="blue" icon="survey" title="Учебный план">
        <ul className={cls.courses}>
          {data.map(({ course_name }, idx) => (
            <li
              className={currentCourse === idx ? cls.activeCourse : ""}
              key={idx}
              onClick={() => {
                setCurrentCourse(idx);
                setCurrPageIndex(0);
              }}
            >
              {course_name}
            </li>
          ))}
        </ul>

        <div className={cls.coursePages}>
          <a
            className={currPageIndex === 0 ? cls.disabledArrow : ""}
            title="Предыдущая страница"
            onClick={() =>
              setCurrPageIndex((prev) => (prev > 0 ? prev - 1 : prev))
            }
          >
            <Icon name="arrow_left" />
          </a>
          <a
            className={
              currPageIndex === pages.length - 1 ? cls.disabledArrow : ""
            }
            title="Следующая страница"
            onClick={() =>
              setCurrPageIndex((prev) =>
                prev < pages.length - 1 ? prev + 1 : prev
              )
            }
          >
            <Icon name="arrow_right" />
          </a>
        </div>
        <div
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchMove={handleTouchMove}
          className={isScrollTable ? cls.scrollTable : cls.table_container}
        >
          <div className={cls.table}>
            <div className={cls.table_thead}>
              {months.map((date, idx) => {
                const days = daysInMonth(date.getMonth(), date.getFullYear());
                return (
                  <LearningHeader
                    key={idx}
                    isShowCurrDate={startDate <= today && today <= endDate}
                    days={days}
                    tableHeight={tableHeight}
                    date={date}
                    dayToPercentage={dayToPercentage}
                  />
                );
              })}
            </div>
            <div ref={tableRef} className={cls.table_body}>
              {leftPaddingDays > 0 && (
                <div
                  key="left-padding-body"
                  className={cls.padding_cell}
                  style={{ flexBasis: `${dayToPercentage(leftPaddingDays)}%` }}
                />
              )}

              {restoredColumns.map((column, colIndex) => {
                const flexBasisValue = dayToPercentage(column.days_count);

                const columnPercentage = flexBasisValue; // Процент ширины колонки
                if (column.column_index === "КАНИКУЛЫ") {
                  return (
                    <div
                      key={colIndex}
                      title="КАНИКУЛЫ"
                      className={cls.holiday}
                      style={{
                        flexBasis: `${flexBasisValue}%`,
                      }}
                    ></div>
                  );
                }
                return (
                  <div
                    key={colIndex}
                    className={cls.column}
                    style={{
                      flexBasis: `${flexBasisValue}%`,
                      position: "relative",
                    }}
                  >
                    {twoDimensionalArray.map((row, rowIndex) => {
                      const cellData = row[colIndex];

                      if (column.rows[rowIndex]?.isEmpty)
                        return <div style={{ height: "5rem" }}></div>;
                      if (cellData) {
                        const percent_paid =
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].percent_paid;
                        const percent_complete =
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].percent_complete;
                        const is_elective =
                          semesters[cellData.semester_id].ind_mod_discip_id[
                            cellData.ind_mod_discip_id
                          ].is_elective;

                        const colorIndex =
                          arr.indexOf(cellData.ind_mod_discip_id) %
                          zetColors.length;
                        const desiredOverallPercentage = dayToPercentage(
                          cellData.maxTotalDays
                        );
                        const zetWidth = calculateInnerWidth(
                          desiredOverallPercentage,
                          columnPercentage
                        );

                        return (
                          <React.Fragment key={`${rowIndex}-${colIndex}`}>
                            <div style={{ position: "relative" }}>
                              <div
                                className={cls["cell-label"]}
                                style={
                                  cellData.renderLabel && {
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                    width: `calc(${zetWidth}% - 20px)`,
                                  }
                                }
                              >
                                {cellData.renderLabel && (
                                  <div>
                                    <div
                                      title={cellData.discip_short_name}
                                      style={{
                                        width: "100%",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {cellData.discip_short_name}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div
                              onMouseEnter={() => highlightCell(cellData)}
                              onMouseLeave={() => setCurrCellBorder({})}
                            >
                              <Cell
                                rowIndex={rowIndex}
                                colIndex={colIndex}
                                cellData={cellData}
                                color={zetColors[colorIndex]}
                                twoDimensionalArray={twoDimensionalArray}
                                width={width}
                                height={height}
                                currCellBorder={currCellBorder}
                                getLinegraph={getLinegraph}
                                highlighted={
                                  currCellBorder.ind_mod_discip_id ===
                                    cellData.ind_mod_discip_id &&
                                  currCellBorder.semester_id ===
                                    cellData.semester_id
                                }
                                is_elective={is_elective}
                                percent_complete={percent_complete}
                                percent_paid={percent_paid}
                                zetWidth={zetWidth}
                              />
                            </div>
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </div>
                );
              })}
              {rightPaddingDays > 0 && (
                <div
                  key="right-padding-body"
                  className={cls.padding_cell}
                  style={{ flexBasis: `${dayToPercentage(rightPaddingDays)}%` }}
                />
              )}
            </div>
          </div>
        </div>
        <LegendLingraph />
      </WidgetFrame>
    </ModalZetLessons>
  );
}

export default LearningPlanMobile;
